import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HospitalRebatePanel from "@/components/hospital/HospitalRebatePanel";

export default function HospitalRebatesPage() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="hospital-rebates-page">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <Link to="/hospital/portal" data-testid="rebates-back-link"
          className="inline-flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-sky-600 transition-colors mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to portal
        </Link>
        <p className="text-[11px] font-black uppercase tracking-[0.2em] text-sky-600 mb-2">
          Secondary Source Rebate Program
        </p>
        <h1 className="text-3xl lg:text-4xl font-black text-slate-900 tracking-tight mb-2">
          Your rebate position
        </h1>
        <p className="text-sm text-slate-500 mb-8">
          Updated on every qualified purchase. Statements are emailed on the 3rd of each month.
        </p>
        <HospitalRebatePanel />
      </div>
    </div>
  );
}
